import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BackEndURLSettings } from '~/services/BackEndURL/backEndUrlSettings';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';

import './app/core/kendo-date-defaults';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

fetch('./assets/scripts/UrlApi.json').then(response => response.json()).then((envConfig: BackEndURLSettings) => {
  EnvironmentLoaderService.envConfig = <BackEndURLSettings>{ ...envConfig };
  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], preserveWhitespaces: true,}).catch(err => console.error(err));
})
